import initialState from './initialState';
import actionType from './actionTypes';

const loaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.ENABLE_LOADER:
            return {
                ...state,
                isLoading: true,
            };
        case actionType.DISABLE_LOADER:
            return {
                isLoading: false,
            };
        case actionType.VALIDATION_MESSAGE:
            return {
                ...state,
                validationMsg: action.payload,
            };
        default:
            return state;
    }
};

export default loaderReducer;
